import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Card, Container, Grid, Typography } from "@mui/material";
import { groupBy, uniqBy } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect, {
  default as Select,
} from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import {
  createClinicService,
  editClinicService,
  getClinicStocks,
  getServiceCategoryByType,
  getServices,
  updateServiceStatusByIds,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { routeList, ServiceTypes } from "../../../util/dropList";
import { getTotalEstimatedCost } from "../../../util/function";

const tableHeaders = [
  "checkbox",
  "serviceName",
  "category",
  "serStatus",
  "subCategory",
  "hsnSacCode",
  "sellingPrice",
  // "tax",
  "cgst",
  "sgst",
];

const initialValues = {
  type: "medical",
  category: null,
  subCategory: null,
  serviceName: "",
  taxApplicability: "Yes",
  servicePrice: "",
  tax: "",
  cgst: "",
  sgst: "",
  description: "",
  hsnSacCode: "",
  consumList: [],
  presList: [],
};
const initialError = {
  category: false,
  subCategory: false,
  serviceName: false,
  taxApplicability: false,
  servicePrice: false,
  tax: false,
  cgst: false,
  sgst: false,
  description: false,
  hsnSacCode: false,
};

const initialHelp = {
  category: "",
  subCategory: "",
  serviceName: "",
  taxApplicability: "",
  servicePrice: "",
  tax: "",
  cgst: "",
  sgst: "",
  description: "",
  hsnSacCode: "",
};

const requiredFieldList = [
  "category",
  "subCategory",
  "serviceName",
  "servicePrice",
  // "tax",
  "cgst",
  "sgst",
];

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
};
const plusBtn = { color: AppColors.appPrimary, width: 15, height: 15 };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const arrow = { width: 30, height: 30, color: AppColors.appPrimary };
const initItem = { name: "", quantity: "1", cost: 0, delete: false };

const Service = () => {
  const dispatch = useDispatch();
  const [serviceValues, setServiceValues] = useState(initialValues);
  const [serviceErrors, setServiceErrors] = useState(initialError);
  const [serviceHelps, setServiceHelps] = useState(initialHelp);
  const [serviceId, setServiceId] = useState(null);
  const [modVisible, setModVisible] = useState(false);
  const [tableServices, setTableServices] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [consumOpen, setConsumOpen] = useState(true);
  const [adminOpen, setAdminOpen] = useState(true);
  const { services, serviceCategories } = useSelector((state) => state?.clinic);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const rowsPerPage = 10;
  const defaultUrl = `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`;

  useEffect(() => {
    dispatch(getServiceCategoryByType("medical"));
  }, []);

  useEffect(() => {
    dispatch(getServices(defaultUrl));
    setPage(1);
  }, [searchValue]);

  useEffect(() => {
    getSupplierTableData();
  }, [services?.data]);

  const handleChangeCheckBox = (value, ind) => {
    const reqList = tableServices?.map((ser, i) => {
      if (i === ind) {
        return { ...ser, selected: value };
      }
      return ser;
    });
    setTableServices(reqList);
  };

  const getSupplierTableData = () => {
    const reqList = services?.data?.map((ser, i) => {
      return {
        ...ser,
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div
            className="cursor blue-color underline font-bold fs14"
            onClick={() => handleEditModal(ser?.serviceId)}
          >
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: ser?.servicePrice,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        hsnSacCode: ser?.hsnSacCode,
        tax: ser?.tax,
        cgst: ser?.cgst,
        sgst: ser?.sgst,
        selected: false,
      };
    });
    setTableServices(reqList);
  };

  const getSupplierTable = () => {
    return tableServices?.map((ser, i) => {
      return {
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div
            className="cursor"
            onClick={() => handleEditModal(ser?.serviceId)}
          >
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: ser?.servicePrice,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        hsnSacCode: ser?.hsnSacCode,
        tax: ser?.tax,
        cgst: ser?.cgst,
        sgst: ser?.sgst,
        selected: ser?.selected,
      };
    });
  };

  const handleOpen = () => {
    dispatch(getClinicStocks());
    setModVisible(true);
  };

  const handleClose = () => {
    setModVisible(false);
    setServiceValues(initialValues);
    setServiceErrors(initialError);
    setServiceHelps(initialHelp);
  };

  const handleSubmit = async () => {
    let errObj = {};
    let hlpObj = {};
    requiredFieldList?.forEach((fld) => {
      const reqValue =
        typeof serviceValues?.[fld] === "object"
          ? serviceValues?.[fld]?.value
          : serviceValues?.[fld];
      if (
        reqValue?.length === 0 || typeof reqValue === "number"
          ? false
          : !reqValue
      ) {
        errObj = { ...errObj, [fld]: true };
        hlpObj = { ...hlpObj, [fld]: "This field is required" };
      } else {
        errObj = { ...errObj, [fld]: false };
        hlpObj = { ...hlpObj, [fld]: "" };
      }
    });
    setServiceErrors({ ...serviceErrors, ...errObj });
    setServiceHelps({ ...serviceHelps, ...hlpObj });
    if (Object.keys(errObj)?.some((val) => errObj?.[val] === true)) return;
    const serviceData = {
      active: serviceValues?.active ? "N" : "Y",
      type: serviceValues?.type,
      category: serviceValues?.category?.value,
      subCategory: serviceValues?.subCategory?.value,
      serviceName: serviceValues?.serviceName,
      taxApplicability: serviceValues?.taxApplicability,
      servicePrice: Number(serviceValues?.servicePrice),
      tax: parseFloat(serviceValues?.cgst) + parseFloat(serviceValues?.sgst),
      cgst: parseFloat(serviceValues?.cgst),
      sgst: parseFloat(serviceValues?.sgst),
      description: serviceValues?.description,
      hsnSacCode: serviceValues?.hsnSacCode,
    };
    let serviceDetails = [];
    let servicePrescription = [];
    if (serviceValues?.consumList?.length > 0) {
      serviceDetails = serviceValues?.consumList?.map((li) => {
        const reqObj = {
          name: li?.name,
          quantity: Number(li?.quantity),
          estimatedCost: Number(li?.cost),
        };
        if (li?.detailId) reqObj.detailId = li?.detailId;
        if (serviceId) {
          reqObj.delete = li?.delete;
        } else {
          reqObj.delete = false;
        }
        return reqObj;
      });
    }
    if (serviceValues?.presList?.length > 0) {
      servicePrescription = serviceValues?.presList?.map((pre) => {
        const reqObj = {
          administered: "Administered",
          type: pre?.type ?? null,
          name: pre?.name ?? null,
          dosage: pre?.dosage,
          quantity: 1,
          vaccineType: pre?.route?.value,
          duration: "1",
          stockId: pre?.stockId ?? null,
          batchId: pre?.batchId ?? null,
        };
        if (pre?.prescriptionId) reqObj.prescriptionId = pre?.prescriptionId;
        if (serviceId) {
          reqObj.delete = pre?.delete;
        } else {
          reqObj.delete = false;
        }
        return reqObj;
      });
    }
    serviceData.serviceDetails = serviceDetails;
    serviceData.servicePrescription = servicePrescription;
    try {
      if (serviceId) {
        dispatch(editClinicService({ id: serviceId, data: serviceData })).then(
          (res) => {
            if (res?.payload) {
              dispatch(
                getServices(
                  `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`
                )
              );
              setPage(1);
              setModVisible(!modVisible);
              setServiceId(null);
              setServiceValues(initialValues);
            }
          }
        );
      } else {
        dispatch(createClinicService(serviceData)).then((res) => {
          if (res?.payload) {
            dispatch(
              getServices(
                `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`
              )
            );
            setPage(1);
            setModVisible(!modVisible);
            setServiceId(null);
            setServiceValues(initialValues);
          }
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChangePage = (e, selectedPage) => {
    setPage(selectedPage);
    setTableServices([]);
    dispatch(
      getServices(
        `?page=${selectedPage}&itemSize=${rowsPerPage}&search=${searchValue}`
      )
    );
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setPage(1);
    setTableServices([]);
  };

  const handleChange = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...serviceValues, [name]: value };
    let errObj = { ...serviceErrors, [name]: false };
    let hlpObj = { ...serviceHelps, [name]: "" };
    if (name === "sgst" || name === "cgst") {
      reqObj.cgst = value;
      reqObj.sgst = value;
      errObj.cgst = value?.length > 0 ? false : true;
      errObj.sgst = value?.length > 0 ? false : true;
      hlpObj.cgst = value?.length > 0 ? "" : "This field is required";
      hlpObj.sgst = value?.length > 0 ? "" : "This field is required";
    }
    if (reqValue?.length > 0) {
      if (name === "type") {
        dispatch(getServiceCategoryByType(value));
      }
      if (name === "category") {
        reqObj.subCategory = null;
      }
    } else {
      errObj = {
        ...errObj,
        [name]: requiredFieldList?.includes(name) ? true : false,
      };
      hlpObj = {
        ...hlpObj,
        [name]: requiredFieldList?.includes(name)
          ? "This field is required"
          : "",
      };
    }
    setServiceHelps(hlpObj);
    setServiceErrors(errObj);
    setServiceValues(reqObj);
  };

  const handleEditModal = (id) => {
    const selectedProduct = services?.data?.find(
      (product) => product?.serviceId === id
    );
    if (selectedProduct) {
      const reqObj = {
        ...serviceValues,
        active: selectedProduct?.active === "N",
        category:
          getServiceCategories()?.find(
            (cat) => cat?.value === selectedProduct?.category
          ) ?? null,
        subCategory:
          getSubCategoriesByCategory(selectedProduct?.category)?.find(
            (cat) => cat?.value === selectedProduct?.subCategory
          ) ?? null,
        serviceName: selectedProduct?.serviceName,
        taxApplicability: selectedProduct?.taxApplicability,
        servicePrice: selectedProduct?.servicePrice,
        tax: parseFloat(selectedProduct?.tax),
        cgst: parseFloat(selectedProduct?.cgst),
        sgst: parseFloat(selectedProduct?.sgst),
        description: selectedProduct?.description,
        hsnSacCode: selectedProduct?.hsnSacCode,
      };
      if (selectedProduct?.serviceDetails?.length > 0) {
        reqObj.consumList = selectedProduct?.serviceDetails?.map((li) => ({
          detailId: li?.detailId,
          name: li?.name,
          quantity: li?.quantity,
          cost: li?.estimatedCost,
          delete: false,
        }));
      }
      if (selectedProduct?.servicePrescreiptions?.length > 0) {
        reqObj.presList = selectedProduct?.servicePrescreiptions?.map((li) => {
          const batch = getBatchList(li?.stockId)?.find(
            (bat) => bat?.batchId === li?.batchId
          );
          return {
            prescriptionId: li?.prescriptionId,
            name: li?.name,
            stockId: li?.stockId,
            batchId: li?.batchId,
            quantity: li?.quantity,
            administered: "Administered",
            route: routeList?.find((rl) => rl?.value === li?.vaccineType),
            dosage: li?.dosage,
            type: li?.type,
            duration: li?.duration,
            batchNumber: batch,
            cost: batch?.unitSellingPrice,
            delete: false,
          };
        });
      }
      setServiceValues(reqObj);
      setServiceId(id);
      setModVisible(!modVisible);
    }
  };

  const handleAction = (value) => {
    if (value === "Disable" || value === "Enable") {
      if (!tableServices?.find((li) => li?.selected)) return;
      const ids = tableServices
        ?.filter((li) => li?.selected)
        ?.map((li) => li?.serviceId);
      dispatch(
        updateServiceStatusByIds({
          ids,
          active:
            tableServices?.find((li) => li?.selected)?.active === "Y"
              ? false
              : true,
        })
      ).then((res) => {
        if (res?.payload) {
          dispatch(
            getServices(
              `?page=${page}&itemSize=${rowsPerPage}&search=${searchValue}`
            )
          );
        }
      });
    }
  };

  const getServiceCategories = () => {
    if (serviceCategories?.length === 0 || !serviceCategories) return [];
    const uniqList = uniqBy(serviceCategories, "category");
    if (uniqList?.length > 0) {
      const reqList = uniqList?.map((cat) => ({
        ...cat,
        name: cat?.category,
        value: cat?.category,
      }));
      return reqList;
    }
    return [];
  };

  const getSubCategoriesByCategory = (value) => {
    const groupData = groupBy(serviceCategories, "category");
    let reqList = [];
    if (groupData?.[value]?.length > 0) {
      reqList = groupData?.[value]?.map((cat) => ({
        ...cat,
        name: cat?.subCategory,
        value: cat?.subCategory,
      }));
    }
    return reqList;
  };

  const handleConsumOpen = () => {
    setConsumOpen(!consumOpen);
  };

  const handleAdminOpen = () => {
    setAdminOpen(!adminOpen);
  };

  const getStockBatch = (stockId, batchId) => {
    const selStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const reqBatc = selStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return reqBatc;
  };

  const handleConsumDelete = (ind) => {
    let reqList = [];
    if (serviceId) {
      reqList = serviceValues?.consumList?.map((li, i) => {
        if (i === ind) {
          return { ...li, delete: true };
        }
        return li;
      });
    } else {
      reqList = serviceValues?.consumList
        ?.filter((li, i) => i !== ind)
        ?.map((li, i) => {
          return { ...li, i };
        });
    }
    setServiceValues({ ...serviceValues, consumList: reqList });
  };

  const handleConsumChange = (name, value, ind, addObj) => {
    const reqList = serviceValues?.consumList?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.cost = reqCost;
          }
          if (addObj?.serviceId) {
            const reqService = services?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks?.data
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              (Number(reqBatch?.unitSellingPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                services?.data?.find((ser) => ser?.serviceId === li?.serviceId)
                  ?.servicePrice
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        return reqObj;
      }
      return li;
    });
    setServiceValues({ ...serviceValues, consumList: reqList });
  };

  const handleAddTask = (typ) => {
    let consumList = serviceValues?.consumList;
    let presList = serviceValues?.presList;
    if (typ === "consum") {
      const reqList = [
        ...serviceValues?.consumList,
        { ...initItem, i: serviceValues?.consumList?.length },
      ];
      consumList = reqList;
    }
    if (typ === "pres") {
      const reqList = [
        ...serviceValues?.presList,
        { ...initItem, i: serviceValues?.presList?.length },
      ];
      presList = reqList;
    }
    setServiceValues({ ...serviceValues, consumList, presList });
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      ?.filter((btch) => btch?.billlable === "Y" && btch?.quantity > 0)
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        unitSellingPrice: btch?.unitSellingPrice,
      }));
    return filteredBatches;
  };

  const getList = (isPres = false) => {
    let reqList = [];
    if (isPres) {
      reqList = stocks?.data?.filter((dta) => {
        return (
          (dta?.category?.toLowerCase() === "medication" ||
            dta?.category?.toLowerCase() === "diet" ||
            dta?.category?.toLowerCase() === "nutrition and supplements") &&
          dta?.stockBatch?.find(
            (btch) => btch?.billlable === "Y" && btch?.quantity > 0
          )
        );
      });
    } else {
      reqList = stocks?.data?.filter((dta) => {
        return dta?.stockBatch?.find(
          (btch) => btch?.billlable === "N" && btch?.quantity > 0
        );
      });
    }
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const handleChangeAdminsterValue = (name, value, ind, addObj) => {
    const reqList = serviceValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
        }
        if (name === "batchNumber" && addObj) {
          reqObj.batchId = addObj?.batchId;
          reqObj.cost = getBatchList(pl?.stockId)?.find(
            (bat) => bat?.batchId === addObj?.batchId
          )?.unitSellingPrice;
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setServiceValues({ ...serviceValues, presList: reqList });
  };

  const deleteAdministerByIndex = (ind) => {
    let reqList = [];
    if (serviceId) {
      reqList = serviceValues?.presList?.map((rl, i) => {
        if (i === ind) {
          return { ...rl, delete: true };
        }
        return rl;
      });
    } else {
      reqList = serviceValues?.presList
        ?.filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    setServiceValues({ ...serviceValues, presList: reqList });
  };

  return (
    <Container maxWidth="xl">
      <div className="com-mar back-white pv10">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <div className="flex-row">
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ width: "300px" }}
            >
              <CustomTextField
                placeholder="Search"
                fullWidth
                backgroundColor={AppColors.lightPink}
                value={searchValue}
                handleChange={handleSearch}
              />
            </Grid>
          </div>
          <div className="ml20">
            <CustomButton text="Create" smallBtn onClick={handleOpen} />
          </div>
          <div className="ml10">
            <SplitButton
              list={
                tableServices?.find((li) => li?.active === "Y" && li?.selected)
                  ? ["Disable"]
                  : ["Enable"]
              }
              handleClickItem={handleAction}
            />
          </div>
          <div className="pos-absolute r80">
            <Typography className="font-medium fs16">
              Total number of services: {services?.totalRecords}
            </Typography>
          </div>
        </Grid>

        <Table
          columns={tableHeaders}
          datas={getSupplierTable()}
          page={page}
          rowsPerPage={rowsPerPage}
          totalRecords={services?.totalRecords}
          handleChangePage={handleChangePage}
          grey
          product={true}
        />

        <CustomModal
          open={modVisible}
          onClose={handleClose}
          header={serviceId ? "Edit" : "Create"}
          modal
          modalWidth={80}
        >
          <div className="scroll-80vh">
            <Grid container spacing={2} className="ph20">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs16 blue-color">
                  Service Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomCheckbox
                  label="Disabled"
                  checked={serviceValues?.active}
                  onChange={() =>
                    handleChange("active", !serviceValues?.active)
                  }
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Type <span className="red-color">*</span>
                </div>
                <Select
                  list={ServiceTypes}
                  value={serviceValues?.type}
                  handleChange={(e) => handleChange("type", e?.target?.value)}
                  name="type"
                  select
                  error={serviceErrors?.type}
                  helperText={serviceHelps?.type}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Category <span className="red-color">*</span>
                </div>
                <Select
                  list={getServiceCategories()}
                  value={serviceValues?.category}
                  handleChange={(e, value) => {
                    handleChange("category", value);
                  }}
                  name="category"
                  search
                  error={serviceErrors?.category}
                  helperText={serviceHelps?.category}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Sub-Category <span className="red-color">*</span>
                </div>
                <Select
                  list={getSubCategoriesByCategory(
                    serviceValues?.category?.value
                  )}
                  value={serviceValues?.subCategory}
                  handleChange={(e, value) => {
                    handleChange("subCategory", value);
                  }}
                  name="subCategory"
                  search
                  error={serviceErrors?.subCategory}
                  helperText={serviceHelps?.subCategory}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Procedure name <span className="red-color">*</span>
                </div>
                <CustomTextField
                  name="serviceName"
                  fullWidth
                  helperText={serviceHelps?.serviceName}
                  error={serviceErrors?.serviceName}
                  value={serviceValues?.serviceName}
                  handleChange={(e) =>
                    handleChange("serviceName", e?.target?.value)
                  }
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  HSN/SAC Code
                </div>
                <CustomTextField
                  name="hsnSacCode"
                  fullWidth
                  helperText={serviceHelps?.hsnSacCode}
                  error={serviceErrors?.hsnSacCode}
                  value={serviceValues?.hsnSacCode}
                  handleChange={(e) =>
                    handleChange("hsnSacCode", e?.target?.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="green-back4 ph20 pv10 br10">
                  <div className="flex-row-between-align-center">
                    <Typography className="txt-semi-bold fs14 orange5">
                      Estimated Total Cost:
                    </Typography>
                    <Typography className="font-bold fs14 orange5 ml10">
                      Rs{" "}
                      {Number(
                        getTotalEstimatedCost([
                          ...serviceValues?.consumList,
                          ...serviceValues?.presList,
                        ])
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card sx={cardSty}>
                  <div
                    className="flex-row-ali-cen cursor"
                    onClick={handleConsumOpen}
                  >
                    {consumOpen ? (
                      <ArrowDropDownIcon sx={arrow} />
                    ) : (
                      <ArrowRightIcon sx={arrow} />
                    )}
                    <div className="flex-row-ali-cen">
                      <Typography className="font-bold fs14 blue-color">
                        Consumables
                      </Typography>
                    </div>
                  </div>
                  {consumOpen ? (
                    <div className="flex-column">
                      <div className="flex-row-ali-cen mh10">
                        <div className="w30Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Name
                          </Typography>
                        </div>
                        <div className="w30Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Quantity
                          </Typography>
                        </div>
                        <div className="w30Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Estimated Cost
                          </Typography>
                        </div>
                        <div className="w10Per" />
                      </div>
                      <div className="blue-hor-split mt5" />
                      {serviceValues?.consumList
                        ?.filter((li) => !li?.delete)
                        ?.map((li, i) => {
                          return (
                            <div
                              className="flex-row-ali-cen mt10 plan-bor"
                              key={i + "consum"}
                            >
                              <div className="w30Per pr10">
                                <CustomSelect
                                  list={getList(false)}
                                  value={li?.name}
                                  addNewSelect
                                  mandatoryField
                                  handleChange={(e) => {
                                    handleConsumChange(
                                      "name",
                                      e?.value ?? e,
                                      i,
                                      {
                                        stockId: e?.stockId ?? null,
                                        batchId: e?.batchId ?? null,
                                        serviceId: e?.serviceId ?? null,
                                        category: e?.category ?? null,
                                      }
                                    );
                                  }}
                                  plusBtn
                                />
                              </div>
                              <div className="w30Per pr10">
                                <CustomTextField
                                  value={li?.quantity}
                                  handleChange={(e) =>
                                    handleConsumChange(
                                      "quantity",
                                      e?.target?.value,
                                      i
                                    )
                                  }
                                  fullWidth
                                  type="number"
                                />
                              </div>
                              <div className="w30Per pr10">
                                <Typography className="txt-regular fs12 gray20 ml5">
                                  {Number(li?.cost) > 0
                                    ? `Rs ${li?.cost}`
                                    : "-"}
                                </Typography>
                              </div>
                              <div className="w10Per flex-end">
                                <div className="pr10">
                                  <img
                                    src={require("../../../assets/images/png/delete.png")}
                                    className="imghw30 cursor"
                                    onClick={() => handleConsumDelete(i)}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}

                      <div
                        className="flex-row-ali-cen mt10 cursor"
                        onClick={() => handleAddTask("consum")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={plusBtn} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                    </div>
                  ) : null}
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card sx={cardSty}>
                  <div
                    className="flex-row-ali-cen cursor"
                    onClick={handleAdminOpen}
                  >
                    {adminOpen ? (
                      <ArrowDropDownIcon sx={arrow} />
                    ) : (
                      <ArrowRightIcon sx={arrow} />
                    )}
                    <Typography className="font-bold fs14 blue-color">
                      Administered
                    </Typography>
                  </div>
                  {adminOpen ? (
                    <div className="flex-column">
                      <div className="flex-row-ali-cen mh10">
                        <div className="w30Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Name
                          </Typography>
                        </div>
                        <div className="w25Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Batch Number
                          </Typography>
                        </div>
                        <div className="w20Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Dosage
                          </Typography>
                        </div>
                        <div className="w20Per">
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Route
                          </Typography>
                        </div>
                        <div className="w5Per" />
                      </div>
                      <div className="blue-hor-split mt5" />
                      {serviceValues?.presList
                        ?.filter((li) => !li?.delete)
                        ?.map((pr, ind) => {
                          return (
                            <div
                              className="flex-row-ali-cen mt10 plan-bor"
                              key={ind + "pres"}
                            >
                              <div className="w30Per pr10">
                                <Select
                                  list={getList(true)}
                                  value={pr?.name}
                                  addNewSelect
                                  mandatoryField
                                  handleChange={(e) => {
                                    handleChangeAdminsterValue(
                                      "name",
                                      e?.value ?? e,
                                      ind,
                                      {
                                        stockId: e?.stockId ?? null,
                                        productId: e?.productId ?? null,
                                        serviceId: e?.serviceId ?? null,
                                        type: e?.type,
                                      }
                                    );
                                  }}
                                  plusBtn
                                />
                              </div>
                              <div className="w25Per pr10">
                                <Select
                                  list={getBatchList(pr?.stockId)}
                                  value={pr?.batchNumber}
                                  search
                                  handleChange={(e, value) => {
                                    handleChangeAdminsterValue(
                                      "batchNumber",
                                      value,
                                      ind,
                                      {
                                        batchId: value?.batchId ?? null,
                                      }
                                    );
                                  }}
                                />
                              </div>
                              <div className="w20Per pr10">
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    handleChangeAdminsterValue(
                                      "dosage",
                                      e?.target?.value,
                                      ind
                                    )
                                  }
                                  value={pr?.dosage}
                                />
                              </div>
                              <div className="w20Per pr10">
                                <Select
                                  list={routeList}
                                  value={pr?.route}
                                  search
                                  handleChange={(e, value) => {
                                    handleChangeAdminsterValue(
                                      "route",
                                      value,
                                      ind
                                    );
                                  }}
                                />
                              </div>
                              <div className="w5Per flex-center">
                                <img
                                  src={require("../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 ml10 cursor"
                                  onClick={() => deleteAdministerByIndex(ind)}
                                />
                              </div>
                            </div>
                          );
                        })}

                      <div
                        className="flex-row-ali-cen mt10 cursor"
                        onClick={() => handleAddTask("pres")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                    </div>
                  ) : null}
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs16 blue-color">
                  Price & Taxes
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Selling Price <span className="red-color">*</span>
                </div>

                <CustomTextField
                  fullWidth
                  value={serviceValues?.servicePrice}
                  helperText={serviceHelps?.servicePrice}
                  error={serviceErrors?.servicePrice}
                  handleChange={(e) =>
                    handleChange("servicePrice", e?.target?.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  CGST <span className="red-color">*</span>
                </div>
                <CustomTextField
                  fullWidth
                  value={serviceValues?.cgst}
                  helperText={serviceHelps?.cgst}
                  error={serviceErrors?.cgst}
                  handleChange={(e) => handleChange("cgst", e?.target?.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  SGST <span className="red-color">*</span>
                </div>
                <CustomTextField
                  fullWidth
                  value={serviceValues?.sgst}
                  helperText={serviceHelps?.sgst}
                  error={serviceErrors?.sgst}
                  handleChange={(e) => handleChange("sgst", e?.target?.value)}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <div className="txt-semi-bold fs14 light-grey">
                  Tax <span className="red-color">*</span>
                </div>
                <CustomTextField
                  fullWidth
                  value={serviceValues?.tax}
                  helperText={serviceHelps?.tax}
                  error={serviceErrors?.tax}
                  handleChange={(e) => handleChange("tax", e?.target?.value)}
                />
              </Grid> */}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">Remarks</div>
                <CustomTextField
                  name="description"
                  fullWidth
                  value={serviceValues?.description}
                  error={serviceErrors?.description}
                  helperText={serviceHelps?.description}
                  handleChange={(e) =>
                    handleChange("description", e?.target?.value)
                  }
                  multiline
                />
              </Grid>
            </Grid>

            <div className="mt30 mb20">
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <div className="flex1-end">
                    <div className="flex-row-ali-cen">
                      <div className="mr10">
                        <CustomButton
                          text="Cancel"
                          textBtn
                          onClick={handleClose}
                          color={AppColors.red}
                        />
                      </div>
                      <div className="ml10">
                        <CustomButton text="Submit" onClick={handleSubmit} />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </CustomModal>
      </div>
    </Container>
  );
};

export default Service;
